// extracted by mini-css-extract-plugin
export var chevron = "_2s-2";
export var chevronCollapsed = "_2s-3";
export var collapsibleHeader = "_2s-1";
export var container = "_2s-0";